<template>
    <ul v-if="pager.pages && pager.pages.length" class="pagination new-pager" :style="ulStyles">
        <li v-for="page in pager.pages" :key="page" class="page-item page-number" :class="{'active': pager.currentPage === page}" :style="liStyles">
            <a class="page-link" @click="setPage(page)" :style="aStyles">{{page}}</a>
        </li>
    </ul>
</template>

<script>
    import paginate from 'jw-paginate'

    const defaultLabels = {
        first: 'First',
        last: 'Last',
        previous: 'Previous',
        next: 'Next'
    }

    const defaultStyles = {
        ul: {
            margin: 0,
            padding: 0,
            display: 'inline-block'
        },
        li: {
            listStyle: 'none',
            display: 'inline',
            textAlign: 'center'
        },
        a: {
            cursor: 'pointer',
            padding: '6px 12px',
            display: 'block',
            float: 'left'
        }
    }

    export default {
        props: {
            items: {
                type: Array,
                required: true
            },
            initialPage: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 50
            },
            maxPages: {
                type: Number,
                default: 10
            },
            labels: {
                type: Object,
                default: () => defaultLabels
            },
            styles: {
                type: Object
            },
            disableDefaultStyles: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                pager: {},
                ulStyles: {},
                liStyles: {},
                aStyles: {}
            }
        },
        created () {
            if (!this.$listeners.changePage) {
                throw 'Missing required event listener: "changePage"'
            }

            // set default styles unless disabled
            if (!this.disableDefaultStyles) {
                this.ulStyles = defaultStyles.ul
                this.liStyles = defaultStyles.li
                this.aStyles = defaultStyles.a
            }

            // merge custom styles with default styles
            if (this.styles) {
                this.ulStyles = { ...this.ulStyles, ...this.styles.ul }
                this.liStyles = { ...this.liStyles, ...this.styles.li }
                this.aStyles = { ...this.aStyles, ...this.styles.a }
            }

            // set page if items array isn't empty
            if (this.items && this.items.length) {
                this.setPage(this.initialPage)
            }
        },
        methods: {
            setPage(page) {
                const { items, pageSize, maxPages } = this

                // get new pager object for specified page
                const pager = paginate(items.length, page, pageSize, maxPages)

                // get new page of items from items array
                const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1)

                // update pager
                this.pager = pager

                // emit change page event to parent component
                this.$emit('changePage', pageOfItems)
            }
        },
        watch: {
            items () {
                this.setPage(this.initialPage)
            }
        }
    }
</script>
<style>
ul.pagination.new-pager {
    text-align: left;
}
.new-pager li.total-content {
    border: none;
    margin-right: 20px;
    color: black;
    font-size: 15px;
}
.new-pager .active {
    background-color: #454598;
}
.new-pager .active a {
    color: #ffffff;
}
.pagination.new-pager li{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// JwPagination.vue?3ec24c56